import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { GeofenceTypeV2 } from '@casops/store/apis/geofencesApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFenceTypesOptions = (): DropdownItemProps<GeofenceTypeV2>[] => {
  const { t } = useTranslation();

  const items = useMemo(() => {
    return Object.values(GeofenceTypeV2)
      .map((value: GeofenceTypeV2) => {
        return {
          key: value,
          value,
          stringValue: value,
          label: t(`GeofenceTypeV2.${value}`),
        };
      })
      .sort((a, b) => a.stringValue.localeCompare(b.stringValue));
  }, [t]);

  return items;
};

export default useFenceTypesOptions;
